import { Div, Flex } from '@fastnorth/kraken/components/layout';
import { memo, type ReactElement, useMemo } from 'react';
import { LOCKED_CERTIFICATE_ZOOM } from '../../consts.ts';

export type CertificateContentProps = {
  content: string;
  isLocked?: boolean;
  testId?: string;
};

const CertificateContent = ({
  content,
  isLocked = false,
  testId,
}: CertificateContentProps): ReactElement => {
  // React compares this prop by reference, so a new object would reassign innerHTML
  // on every render, recreating the certificate images and making them flicker.
  const html = useMemo(() => ({ __html: content }), [content]);

  return (
    <Div
      spacing={'0'}
      className={'h-full'}
      data-testid={testId}
      style={{ zoom: isLocked ? LOCKED_CERTIFICATE_ZOOM : 'inherit' }}>
      <Flex
        className={'h-full w-full flex-col center justify-center align-middle z-2'}
        dangerouslySetInnerHTML={html}
      />
    </Div>
  );
};

export default memo(CertificateContent);
